import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { ActiveFilterValues } from '../FilterBar.constants'
import { FilterDropdown } from './FilterDropdown'

export const ActiveFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const filterValues = [
      {
        value: ActiveFilterValues.ACTIVE,
        label: 'Active',
      },
      {
        value: ActiveFilterValues.INACTIVE,
        label: 'Inactive',
      },
    ]

    return (
      <FilterDropdown
        filterParam={FilterParam.ACTIVE}
        filterName={FilterName.ACTIVE}
        filterValues={filterValues}
        isNested={isNested}
      />
    )
  },
)
